import CommonTextInput from '@atoms/CommonTextInput';
import { getStore } from '@store/storeUtils';
import { verticalScale } from '@utils/normalize';
import React from 'react';
import { View, Text } from 'react-native';
import logCustomReasonInput from './analyticsReasonInput';
import styles from './styles';

function CustomReasonInput(props: { setCustomReasonText: (val: string) => void; source: string }): JSX.Element | null {
  const { withdrawalReason, validatedReferralCode } = getStore();
  const { setCustomReasonText, source } = props;

  if (withdrawalReason?.id === 18) {
    return (
      <View style={styles.customReasons}>
        <Text style={{ marginBottom: verticalScale(12) }} variant="lg-bold">
          {withdrawalReason.reason}
        </Text>
        <CommonTextInput
          style={styles.inputStyles}
          onChangeText={(val: string) => setCustomReasonText(val)}
          amplitudeCallBackOnBlur={(val: any) => {
            const textValue = val?.target?.value ?? '';
            logCustomReasonInput(textValue, withdrawalReason, validatedReferralCode, source);
          }}
        />
      </View>
    );
  }

  return null;
}

export default CustomReasonInput;
